import {WellsService} from '@services/Wells/WellsService';
import {useQuery} from '@tanstack/react-query';

type GetInstanceParams = {
    fieldId?: number;
    page?: number;
    size?: number;
};

const wellService = WellsService.getInstance();

export const useWells = (params?: GetInstanceParams, enabled: boolean = true) => {
    const loadWells = () => {
        return wellService.getWells({...params});
    };

    const {data: wells, isPending} = useQuery({
        queryKey: ['/api/wells', params],
        queryFn: loadWells,
        gcTime: 0,
        enabled,
    });

    return {wells, isPending};
};
